import { render, staticRenderFns } from "./UpgradeNewSoftwarePerpetual.vue?vue&type=template&id=7a0b0a3b&"
import script from "./UpgradeNewSoftwarePerpetual.vue?vue&type=script&lang=js&"
export * from "./UpgradeNewSoftwarePerpetual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a0b0a3b')) {
      api.createRecord('7a0b0a3b', component.options)
    } else {
      api.reload('7a0b0a3b', component.options)
    }
    module.hot.accept("./UpgradeNewSoftwarePerpetual.vue?vue&type=template&id=7a0b0a3b&", function () {
      api.rerender('7a0b0a3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/LicenceSetup/UpgradeNewSoftwarePerpetual.vue"
export default component.exports